<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.426"
    height="5.585"
    viewBox="0 0 13.426 5.585"
    :class="$attrs.class"
  >
    <g transform="translate(106.331 -227.876) rotate(90)">
      <g transform="translate(393.287 -359.051) rotate(90)">
        <g transform="translate(207.29 -90.6)">
          <path
            :fill="iconColor"
            class="a"
            d="M244.933,256.011h12.893c.225,0,.348-.177.2-.293l-6.446-5.228a.358.358,0,0,0-.41,0l-6.446,5.228c-.144.116-.021.293.205.293"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'ArrowDown',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 13.426px;
    height: 5.585px;
    display: inline-block;
    vertical-align: middle;
  }
</style>
